(function () {
  "use strict";

  /* ------------------------------------------------------------------
     1. Announcement Bar — localStorage-Close
  ------------------------------------------------------------------ */
  function initAnnouncementBar(barId, storageKey) {
    var bar = document.getElementById(barId);
    if (!bar) return;
    if (localStorage.getItem(storageKey)) {
      bar.style.display = "none";
      return;
    }
    var closeBtn = bar.querySelector("[data-c4o-close]");
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        bar.style.display = "none";
        localStorage.setItem(storageKey, "1");
      });
    }
  }

  /* ------------------------------------------------------------------
     2. Copy to Clipboard
     Usage: <button data-c4o-copy="CARE4ORCAS">CARE4ORCAS</button>
  ------------------------------------------------------------------ */
  function initCopyButtons() {
    var btns = document.querySelectorAll("[data-c4o-copy]");
    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var code = btn.getAttribute("data-c4o-copy");
        var originalHTML = btn.innerHTML;
        function showCopied() {
          btn.textContent = "✓ Kopiert";
          btn.classList.add("c4o-copied");
          setTimeout(function () {
            btn.innerHTML = originalHTML;
            btn.classList.remove("c4o-copied");
          }, 2000);
        }
        navigator.clipboard
          .writeText(code)
          .then(showCopied)
          .catch(function () {
            var ta = document.createElement("textarea");
            ta.value = code;
            ta.style.position = "fixed";
            ta.style.opacity = "0";
            document.body.appendChild(ta);
            ta.select();
            document.execCommand("copy");
            document.body.removeChild(ta);
            showCopied();
          });
      });
    });
  }

  /* ------------------------------------------------------------------
     3. Countdown Timer
     Usage: <span data-c4o-countdown="2026-08-01T23:59:00">
  ------------------------------------------------------------------ */
  function initCountdowns() {
    var els = document.querySelectorAll("[data-c4o-countdown]");
    els.forEach(function (el) {
      var endDateStr = el.getAttribute("data-c4o-countdown");
      var endDate = new Date(endDateStr);

      var dayEl = el.querySelector("[data-countdown-days]");
      var hourEl = el.querySelector("[data-countdown-hours]");
      var minEl = el.querySelector("[data-countdown-mins]");
      var isStructured = dayEl && hourEl && minEl;

      function tick() {
        var now = new Date();
        var diff = endDate - now;
        var days = diff <= 0 ? 0 : Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours =
          diff <= 0
            ? 0
            : Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var mins =
          diff <= 0 ? 0 : Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        if (isStructured) {
          dayEl.textContent = days;
          hourEl.textContent = String(hours).padStart(2, "0");
          minEl.textContent = String(mins).padStart(2, "0");
        } else {
          el.textContent =
            days +
            " Tag" +
            (days !== 1 ? "e" : "") +
            " " +
            String(hours).padStart(2, "0") +
            " Std " +
            String(mins).padStart(2, "0") +
            " Min";
        }
      }
      tick();
      setInterval(tick, 60000);
    });
  }

  /* ------------------------------------------------------------------
     4. Counter Animation (IntersectionObserver)
     Usage: <span data-c4o-count="1234" data-c4o-prefix="" data-c4o-suffix=" €" data-c4o-decimals="2">
  ------------------------------------------------------------------ */
  function animateCount(el, target, duration) {
    var startTime = null;
    var prefix = el.getAttribute("data-c4o-prefix") || "";
    var suffix = el.getAttribute("data-c4o-suffix") || "";
    var decimals = parseInt(el.getAttribute("data-c4o-decimals") || "0", 10);

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = eased * target;
      el.textContent =
        prefix + current.toFixed(decimals).replace(".", ",") + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent =
          prefix + target.toFixed(decimals).replace(".", ",") + suffix;
      }
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var counters = document.querySelectorAll("[data-c4o-count]");
    if (!counters.length) return;

    if (!("IntersectionObserver" in window)) {
      counters.forEach(function (el) {
        var target = parseFloat(el.getAttribute("data-c4o-count"));
        var prefix = el.getAttribute("data-c4o-prefix") || "";
        var suffix = el.getAttribute("data-c4o-suffix") || "";
        var decimals = parseInt(
          el.getAttribute("data-c4o-decimals") || "0",
          10,
        );
        el.textContent =
          prefix + target.toFixed(decimals).replace(".", ",") + suffix;
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !entry.target.dataset.c4oAnimated) {
            entry.target.dataset.c4oAnimated = "1";
            var target = parseFloat(
              entry.target.getAttribute("data-c4o-count"),
            );
            animateCount(entry.target, target, 1500);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 },
    );

    counters.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     5. Newsletter Signup (Brevo DOI)
     Form needs data-brevo-key, data-list-id, data-template-id attrs
  ------------------------------------------------------------------ */
  function initNewsletterForms() {
    var forms = document.querySelectorAll("[data-c4o-newsletter]");
    forms.forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var emailInput = form.querySelector('[type="email"]');
        var submitBtn = form.querySelector('[type="submit"]');
        var container = form.parentElement;
        var successEl = container.querySelector("[data-c4o-success]");
        var errorEl = container.querySelector("[data-c4o-error]");
        var apiKey = form.getAttribute("data-brevo-key");
        var listId = parseInt(form.getAttribute("data-list-id"), 10);
        var templateId = parseInt(form.getAttribute("data-template-id"), 10);
        var email = emailInput.value.trim();

        var formUrl = form.getAttribute("data-brevo-form-url");

        if (!email || (!formUrl && (!apiKey || !listId))) {
          if (errorEl) errorEl.style.display = "block";
          return;
        }

        var originalBtnText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = "...";

        var fetchPromise;

        if (formUrl) {
          // DOI via Brevo hosted form endpoint (no-cors: request goes through,
          // Brevo sends confirmation email, response is opaque but always resolves)
          var fd = new FormData();
          fd.append("EMAIL", email);
          fd.append("email_address_check", "");
          fd.append("locale", "de");
          fetchPromise = fetch(formUrl, {
            method: "POST",
            mode: "no-cors",
            body: fd,
          });
        } else {
          // Fallback: direct contacts API (single opt-in)
          fetchPromise = fetch("https://api.brevo.com/v3/contacts", {
            method: "POST",
            headers: {
              "api-key": apiKey,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: email,
              listIds: [listId],
              updateEnabled: true,
            }),
          }).then(function (resp) {
            if (resp.status !== 201 && resp.status !== 204) {
              throw new Error("status " + resp.status);
            }
          });
        }

        fetchPromise
          .then(function () {
            form.style.display = "none";
            if (successEl) successEl.style.display = "block";
          })
          .catch(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = originalBtnText;
            if (errorEl) errorEl.style.display = "block";
          });
      });
    });
  }

  /* ------------------------------------------------------------------
     6. Unsubscribe from Brevo list
     Form needs data-brevo-key and data-list-id attrs
  ------------------------------------------------------------------ */
  function initUnsubscribeForms() {
    var toggleBtns = document.querySelectorAll("[data-c4o-unsub-toggle]");
    toggleBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var inner = btn.closest(".c4o-footer-cta__inner");
        if (!inner) return;
        var unsubForm = inner.querySelector("[data-c4o-unsub-form]");
        if (!unsubForm) return;
        var isHidden =
          unsubForm.style.display === "none" || unsubForm.style.display === "";
        unsubForm.style.display = isHidden ? "flex" : "none";
      });
    });

    var forms = document.querySelectorAll("[data-c4o-unsub-form]");
    forms.forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var emailInput = form.querySelector('[type="email"]');
        var submitBtn = form.querySelector('[type="submit"]');
        var container = form.parentElement;
        var successEl = container.querySelector("[data-c4o-unsub-success]");
        var errorEl = container.querySelector("[data-c4o-unsub-error]");
        var apiKey = form.getAttribute("data-brevo-key");
        var listId = parseInt(form.getAttribute("data-list-id"), 10);
        var email = emailInput.value.trim();

        if (!email || !apiKey || !listId) {
          if (errorEl) errorEl.style.display = "block";
          return;
        }

        var originalBtnText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = "...";

        fetch(
          "https://api.brevo.com/v3/contacts/lists/" +
            listId +
            "/contacts/remove",
          {
            method: "POST",
            headers: {
              "api-key": apiKey,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ emails: [email] }),
          },
        )
          .then(function (resp) {
            if (resp.status !== 201 && resp.status !== 204) {
              throw new Error("status " + resp.status);
            }
            form.style.display = "none";
            var toggleEl = container.querySelector(
              ".c4o-footer-cta__unsub-toggle",
            );
            if (toggleEl) toggleEl.style.display = "none";
            if (successEl) successEl.style.display = "block";
          })
          .catch(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = originalBtnText;
            if (errorEl) errorEl.style.display = "block";
          });
      });
    });
  }

  /* ------------------------------------------------------------------
     Init
  ------------------------------------------------------------------ */
  document.addEventListener("DOMContentLoaded", function () {
    initAnnouncementBar("c4o-announcement-bar", "c4o_bar_closed");
    initCopyButtons();
    initCountdowns();
    initCounters();
    initNewsletterForms();
    initUnsubscribeForms();
  });
})();
